export default __webpack_public_path__ + "static/media/medical.1d8a0c65.webp";